<div class="gallery-preview" [ngClass]="{'single': isSingleItem}" *ngIf="data" (click)="openOverlay()">
  <div class="gallery-preview__main-element">
    <div class="gallery-preview__element">
      <brt-gallery-item [item]="data.items[0]" [object-fit]="isSingleItem ? 'contain' : 'cover'"></brt-gallery-item>
    </div>
    <div class="gallery-preview__overlay-button" *ngIf="!isSingleItem">
      <brt-button [title]="'Alle Bilder & Videos anzeigen'" [color]="'white'"></brt-button>
    </div>
  </div>

  <div class="gallery-preview__side-element" *ngIf="data.items.length > 1">
    <div class="gallery-preview__element">
      <brt-gallery-item [item]="data.items[1]" [object-fit]="'cover'"></brt-gallery-item>
    </div>
  </div>
  <div class="gallery-preview__side-element" *ngIf="data.items.length > 2">
    <div class="gallery-preview__element">
      <brt-gallery-item [item]="data.items[2]" [object-fit]="'cover'"></brt-gallery-item>
    </div>
  </div>
</div>
